export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 100,
            staffing: 0.1,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 200,
            staffing:0.25,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 300,
            staffing: 0.7,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Small",
                    description: "Small size customer counter (100 sq ft)",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "Medium size customer counter  (200 sq ft)",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "Large size customer counter (300 sq ft)",
                    value: 3
                }
            ]
        }

    ]
}
